import React from 'react'

export const About = () => {
  return (
    <div>
      This is about MyComponents
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure impedit asperiores eaque error blanditiis. Consequuntur sunt mollitia aliquam, labore quisquam debitis dolore iste vero accusantium excepturi ipsum quos unde corporis.</p>
    </div>
  )
}
